import { FC } from "react";
import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { UsersWhoParticipantsOfEventDto } from "@app/data/tribeSwaggerApi";
import { avatarUrlDecorator } from "@app/data/avatarUrl";
import { decorateUsername } from "@utils/decorate-username.utils";

export interface DialogItemProps {
  model: UsersWhoParticipantsOfEventDto
}
export const DialogItem:FC<DialogItemProps> = ({model}) => {
  const name = model.participant_name;
  const username = decorateUsername(model.participant_username);
  return (
    <ListItem>
      <ListItemAvatar>
        <Avatar alt={name} sx={{ width: 40, height: 40 }} src={avatarUrlDecorator(model.participant_avatar_url)}/>
      </ListItemAvatar>
      <ListItemText primary={name} secondary={username}/>
    </ListItem>
  )
}